import { Component } from '../core/Component';
import { Vector2 } from '../core/Vector2';

/**
 * UI element types
 */
export enum UIElementType {
  Text = 'text',
  Button = 'button',
  Panel = 'panel',
  ProgressBar = 'progress_bar',
  Image = 'image',
  Menu = 'menu',
}

/**
 * UI alignment options
 */
export enum UIAlignment {
  TopLeft = 'top_left',
  TopCenter = 'top_center',
  TopRight = 'top_right',
  CenterLeft = 'center_left',
  Center = 'center',
  CenterRight = 'center_right',
  BottomLeft = 'bottom_left',
  BottomCenter = 'bottom_center',
  BottomRight = 'bottom_right',
}

/**
 * UI component for creating beautiful game interfaces
 * Pure data component for UI elements
 */
export class UIComponent extends Component {
  public elementType: UIElementType;
  public text: string;
  public fontSize: number;
  public fontFamily: string;
  public color: string;
  public backgroundColor: string;
  public borderColor: string;
  public borderWidth: number;
  public padding: Vector2;
  public margin: Vector2;
  public alignment: UIAlignment;
  public anchor: Vector2;
  public visible: boolean;
  public interactive: boolean;
  public alpha: number;
  public zIndex: number;

  // Progress bar specific
  public value: number;
  public maxValue: number;
  public fillColor: string;

  // Button specific
  public isHovered: boolean;
  public isPressed: boolean;
  public onClick?: () => void;

  constructor(
    elementType: UIElementType = UIElementType.Text,
    text: string = '',
    fontSize: number = 16,
    color: string = '#FFFFFF'
  ) {
    super();
    this.elementType = elementType;
    this.text = text;
    this.fontSize = fontSize;
    this.fontFamily = 'Arial, sans-serif';
    this.color = color;
    this.backgroundColor = 'transparent';
    this.borderColor = 'transparent';
    this.borderWidth = 0;
    this.padding = new Vector2(8, 4);
    this.margin = new Vector2(0, 0);
    this.alignment = UIAlignment.TopLeft;
    this.anchor = new Vector2(0, 0);
    this.visible = true;
    this.interactive = false;
    this.alpha = 1.0;
    this.zIndex = 0;

    // Progress bar
    this.value = 0;
    this.maxValue = 100;
    this.fillColor = '#00FF00';

    // Button state
    this.isHovered = false;
    this.isPressed = false;
  }

  public clone(): UIComponent {
    const clone = new UIComponent(
      this.elementType,
      this.text,
      this.fontSize,
      this.color
    );

    clone.fontFamily = this.fontFamily;
    clone.backgroundColor = this.backgroundColor;
    clone.borderColor = this.borderColor;
    clone.borderWidth = this.borderWidth;
    clone.padding = this.padding.clone();
    clone.margin = this.margin.clone();
    clone.alignment = this.alignment;
    clone.anchor = this.anchor.clone();
    clone.visible = this.visible;
    clone.interactive = this.interactive;
    clone.alpha = this.alpha;
    clone.zIndex = this.zIndex;
    clone.value = this.value;
    clone.maxValue = this.maxValue;
    clone.fillColor = this.fillColor;
    clone.isHovered = this.isHovered;
    clone.isPressed = this.isPressed;
    clone.onClick = this.onClick;

    return clone;
  }
}
